import { useState } from 'react';
import { 
  FiBook, 
  FiSearch, 
  FiBookmark, 
  FiMessageSquare,
  FiLink2
} from 'react-icons/fi';
import BibleReaderAdvanced from '../components/Bible/BibleReaderAdvanced';
import BibleSearch from '../components/Bible/BibleSearch';
import BibleNotes from '../components/Bible/BibleNotes';
import BibleHighlights from '../components/Bible/BibleHighlights';
import BibleRelations from '../components/Bible/BibleRelations';

/**
 * Página de Biblia de Estudio
 */
export default function BibliaEstudio() {
  const [activeTab, setActiveTab] = useState('reader');

  const tabs = [
    {
      id: 'reader',
      name: 'Lector',
      icon: FiBook,
      description: 'Lee la Biblia con números Strong'
    },
    {
      id: 'search',
      name: 'Búsqueda',
      icon: FiSearch,
      description: 'Busca por palabra o Strong'
    },
    {
      id: 'notes',
      name: 'Notas',
      icon: FiMessageSquare,
      description: 'Administra tus notas de estudio'
    },
    {
      id: 'highlights',
      name: 'Subrayados',
      icon: FiBookmark,
      description: 'Ve tus versículos destacados'
    },
    {
      id: 'relations',
      name: 'Relaciones',
      icon: FiLink2,
      description: 'Gestiona relaciones de estudio'
    }
  ];

  return (
    <div className="min-h-full bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Tabs de navegación */}
        <div className="bg-white rounded-xl shadow-md mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px overflow-x-auto">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-2 px-6 py-4 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                      activeTab === tab.id
                        ? 'border-blue-600 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    {tab.name}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Contenido según tab activo */}
        <div>
          {activeTab === 'reader' && <BibleReaderAdvanced />}
          {activeTab === 'search' && <BibleSearch />}
          {activeTab === 'notes' && <BibleNotes />}
          {activeTab === 'highlights' && <BibleHighlights />}
          {activeTab === 'relations' && <BibleRelations />}
        </div>
      </div>
    </div>
  );
}
